import i18n from 'i18n-js';

import { machineStatus, machineStatusColorName } from '@helpers';
import { WithColorProps } from '@styles/colors/types';

export interface StatusSegment {
  color: string;
  count: number;
  name: string;
}

export type StatusesCount = Record<(typeof machineStatus)[keyof typeof machineStatus], number>;

export const getStatusSegments = (C: WithColorProps['C'], count: StatusesCount): StatusSegment[] => {
  return [
    {
      color: C(machineStatusColorName[machineStatus.ACTIVE]),
      count: count[machineStatus.ACTIVE],
      name: i18n.t('Active'),
    },
    {
      color: C(machineStatusColorName[machineStatus.CHANGE]),
      count: count[machineStatus.CHANGE],
      name: i18n.t('Change'),
    },
    {
      color: C(machineStatusColorName[machineStatus.SETUP]),
      count: count[machineStatus.SETUP],
      name: i18n.t('Setup'),
    },
    {
      color: C(machineStatusColorName[machineStatus.NOTPRODUCTIVE]),
      count: count[machineStatus.NOTPRODUCTIVE],
      name: i18n.t('Not Productive'),
    },
  ];
};
